import React, {FC} from 'react';

import {EventStatus, TeamInfo} from 'utils/types';

import './styles.scss';

import teamHomeLogoFallback from 'assets/img/team-home-logo-placeholder.png'; // TODO: svg and colorize
import teamAwayLogoFallback from 'assets/img/team-away-logo-placeholder.png'; // TODO: svg and colorize

interface Props {
  teams: {home: TeamInfo; away: TeamInfo};
  scores: {home: number; away: number};
  isApp?: boolean;
  status?: string;
  minute?: number;
  stoppageTime?: number;
  matchStatus?: string;
  visible?: boolean;
}

const HeaderMini: FC<Props> = ({
  teams,
  scores,
  minute,
  stoppageTime,
  status,
  matchStatus,
  visible = false,
  isApp = false,
}: Props) => {
  return (
    <div
      className={`HeaderMini ${visible ? 'HeaderMini--visible' : ''} ${
        isApp ? 'HeaderMini--app' : ''
      }`}
    >
      <div className="HeaderMini__spacer-left" />
      <section className="HeaderMini__scoreboard">
        <h2 className="HeaderMini__teamName">{teams.home.shortName}</h2>
        <img
          className="HeaderMini__teamLogo"
          src={teams.home.imageUrl || teamHomeLogoFallback}
          width="40"
          height="40"
          alt={teams.home.name}
        />
        <span className="HeaderMini__teamScore">{scores.home ?? '-'}</span>
        <span className="HeaderMini__matchStatus">
          {(status as EventStatus) === EventStatus.LIVE &&
          minute !== null &&
          minute !== undefined &&
          matchStatus !== 'ΗΜΙ'
            ? `${minute}'${stoppageTime ? ` + ${stoppageTime}` : ''}`
            : matchStatus}
        </span>
        <span className="HeaderMini__teamScore">{scores.away ?? '-'}</span>
        <img
          className="HeaderMini__teamLogo"
          src={teams.away.imageUrl || teamAwayLogoFallback}
          width="40"
          height="40"
          alt={teams.away.name}
        />
        <h2 className="HeaderMini__teamName">{teams.away.shortName}</h2>
      </section>
      <div className="HeaderMini__spacer-right" />
    </div>
  );
};

export default HeaderMini;
